import React from 'react'
import { FormContatti, Page } from 'components/organisms'
import { DOMAIN } from 'utils/settings'
import Head from 'next/head'
import { useRouter } from 'next/router'

interface Props {
  pagina?: string
}

const ContattaciTemplate = (props: Props) => {
  const { pagina = '' } = props
  const router = useRouter()

  const jsonLd = {
    '@context': 'http://schema.org',
    '@type': 'ContactPage',
    'name': 'Contattaci - Vinicum',

    'description':
      'Non hai trovato la risposta che cercavi tra le Domande Frequenti? Contattaci via WhatsApp, email o tramite il nostro form di contatto.',
    'url': `${
      router.locale === 'en'
        ? `${DOMAIN}/${router.locale}${pagina['url']}`
        : `${DOMAIN}${pagina['url']}`
    }`,
    'publisher': {
      '@type': 'Organization',
      'name': 'Vinicum',
      'url': `${
        router.locale === 'en'
          ? `${DOMAIN}/${router.locale}${pagina['url']}`
          : `${DOMAIN}${pagina['url']}`
      }`,
      'contactPoint': {
        '@type': 'ContactPoint',
        'telephone': '+39 350 162 2708',
        'contactType': 'customer support',
        'contactOption': 'TollFree',
        'areaServed': 'IT',
        'availableLanguage': ['Italian', 'English'],
      },
    },
  }

  return (
    <>
      <Head>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
        />
      </Head>

      <Page hideBreadcrumbs pagina={pagina} containerVariant="sm" className="contattaci-template">
        <FormContatti />
      </Page>
    </>
  )
}
export default ContattaciTemplate
